module.exports = __webpack_public_path__ + "static/media/maracaibo.cc921ab2.png";